// Mock data for AIGENTO AI Automation website
// This will be replaced with backend API calls later

export const mockData = {
  // Hero section data
  hero: {
    announcement: "AI Automation Solutions",
    title: "Transform Your Local Business with AI Agents",
    subtitle: "Automate scheduling, customer service, and CRM management with intelligent AI agents built specifically for local service businesses.",
    primaryCTA: "Automate Your Business Now",
    secondaryCTA: "Book a Demo"
  },

  // How it works process
  howItWorks: [
    {
      step: 1,
      title: "Assessment & Setup",
      description: "We analyze your current workflow and identify automation opportunities in your business processes."
    },
    {
      step: 2,
      title: "AI Agent Configuration",
      description: "Custom AI agents are built using n8n, Firebase, and Twilio to handle your specific business needs."
    },
    {
      step: 3,
      title: "Voice & SMS Integration",
      description: "ElevenLabs voice AI and SMS automation are integrated to handle customer interactions 24/7."
    },
    {
      step: 4,
      title: "Launch & Optimization",
      description: "Your AI agents go live, continuously learning and improving to serve your customers better."
    }
  ],

  // Services/Plans
  services: [
    {
      id: 1,
      name: "Pro Plan",
      price: "$997",
      period: "per month",
      description: "Essential automation for growing businesses",
      features: [
        "Automated call handling",
        "SMS appointment reminders",
        "Basic appointment booking",
        "Email integration",
        "Business hours management",
        "Customer data sync"
      ],
      accent: "accent-blue",
      popular: false
    },
    {
      id: 2,
      name: "Elite Plan",
      price: "$1,997",
      period: "per month",
      description: "Complete AI automation suite with advanced features",
      features: [
        "Everything in Pro Plan",
        "Advanced voice AI with ElevenLabs",
        "Full CRM integration",
        "Automated lead follow-ups",
        "Analytics dashboard",
        "Multi-channel support",
        "Custom workflow automation",
        "Priority support"
      ],
      accent: "accent-orange",
      popular: true
    }
  ],

  // Testimonials
  testimonials: [
    {
      id: 1,
      name: "Sarah Johnson",
      business: "Elite Hair Salon",
      location: "Miami, FL",
      quote: "AIGENTO's AI agents have transformed our scheduling. We've reduced missed appointments by 80% and our customers love the 24/7 availability.",
      savings: "$3,200/month in reduced no-shows"
    },
    {
      id: 2,
      name: "Mike Rodriguez",
      business: "Rodriguez Plumbing",
      location: "Austin, TX",
      quote: "The voice AI handles emergency calls even when we're on-site. Our response time improved dramatically and customer satisfaction is through the roof.",
      savings: "150% increase in emergency bookings"
    },
    {
      id: 3,
      name: "Jennifer Chen",
      business: "Chen Legal Services",
      location: "San Francisco, CA",
      quote: "Client intake and follow-ups are now fully automated. We can focus on practicing law while AI handles the administrative work seamlessly.",
      savings: "20 hours/week saved on admin"
    }
  ],

  // Industries served
  industries: [
    {
      name: "Healthcare",
      description: "Medical offices, dental practices, therapy clinics",
      icon: "Heart"
    },
    {
      name: "Legal Services",
      description: "Law firms, attorneys, legal consultants",
      icon: "Scale"
    },
    {
      name: "Home Services",
      description: "Plumbers, electricians, HVAC, landscaping",
      icon: "Wrench"
    },
    {
      name: "Beauty & Wellness",
      description: "Salons, spas, fitness centers, barbershops",
      icon: "Sparkles"
    },
    {
      name: "Professional Services",
      description: "Accountants, consultants, real estate",
      icon: "Building"
    },
    {
      name: "Automotive",
      description: "Auto repair, detailing, car dealerships",
      icon: "Car"
    }
  ],

  // Company info
  company: {
    name: "AIGENTO",
    tagline: "AI Automation for Local Businesses",
    description: "We specialize in building intelligent AI agents that automate scheduling, customer service, and CRM management for local service businesses.",
    email: "hello@aigento.com",
    phone: "+1 (555) 123-4567",
    address: "123 Innovation Drive, Tech City, TC 12345"
  },

  // Contact form fields
  contactForm: {
    fields: [
      { name: "firstName", label: "First Name", type: "text", required: true },
      { name: "lastName", label: "Last Name", type: "text", required: true },
      { name: "email", label: "Email Address", type: "email", required: true },
      { name: "phone", label: "Phone Number", type: "tel", required: false },
      { name: "business", label: "Business Name", type: "text", required: true },
      { name: "industry", label: "Industry", type: "select", required: true },
      { name: "message", label: "Tell us about your business needs", type: "textarea", required: true }
    ]
  }
};